export * from './domain';
export * from './dto';
export * from './builders';
export var createTicketsSlaInsightsApi = function (baseUrl, http) {
    var ticketsUrl = "".concat(baseUrl, "/analytics/tickets");
    var slaUrl = "".concat(ticketsUrl, "/sla");
    return {
        getOverview: function (dto) { return http.post("".concat(ticketsUrl, "/overview"), dto); },
        getComplianceCumulative: function (dto) { return http.post("".concat(slaUrl, "/compliance/cumulative"), dto); },
        getComplianceHistogram: function (dto) { return http.post("".concat(slaUrl, "/compliance/histogram"), dto); },
        getElapsedTimeCumulative: function (dto) { return http.post("".concat(slaUrl, "/elapsedTime/cumulative"), dto); },
        getElapsedTimeHistogram: function (dto) { return http.post("".concat(slaUrl, "/elapsedTime/histogram"), dto); },
        getMissCountCumulative: function (dto) { return http.post("".concat(slaUrl, "/missCount/cumulative"), dto); },
        getMissCountHistogram: function (dto) { return http.post("".concat(slaUrl, "/missCount/histogram"), dto); },
        getMissTimeCumulative: function (dto) { return http.post("".concat(slaUrl, "/missTime/cumulative"), dto); },
        getMissTimeHistogram: function (dto) { return http.post("".concat(slaUrl, "/missTime/histogram"), dto); },
    };
};
//# sourceMappingURL=index.js.map